module.exports = __webpack_public_path__ + "64203c25fb1254f5bc28fc8aa573de6f.png";